import { extend } from 'lodash'
import { createSlice } from '@reduxjs/toolkit'

import { selectAllItems } from './selectors'

const initialState = {
	database: {
		id: 0,
		name: '',
		error: null,
		structure: [],
	},
	items: {
		data: [],
		pages: {
			page: 0,
			per_page: 10,
			total: 0,
		},
		error: null,
		loading: false,
	},
	editedRow: {
		data: [],
		error: null,
		loading: false,
	},
	showModal: false,
	loading: false,
	databases: [],
}

const { actions, reducer } = createSlice({
	name: 'internalDatabaseDetails',
	initialState,
	reducers: {
		resetState: () => initialState,

		getDetail: (state, { payload }) =>
			extend(state, {
				database: {
					...initialState.database,
					loading: true,
					id: payload.id,
				},
				items: { ...initialState.items, loading: true },
			}),
		getDetailSuccess: (state, { payload }) =>
			extend(state, {
				database: {
					...state.database,
					name: payload.name,
					structure: payload.structure,
					loading: false,
				},
			}),
		getDetailFailure: (state, { payload }) =>
			extend(state, {
				database: {
					...state.database,
					error: payload.error,
					loading: false,
				},
			}),

		listRows: (state) => extend(state, { loading: true }),

		listRowsSuccess: (state, { payload }) =>
			extend(state, {
				loading: false,
				items: {
					data: selectAllItems(payload.items),
					pages: {
						page: payload.page,
						per_page: payload.per_page,
						total: payload.total,
					},
					error: null,
				},
				databases: [
					...state.databases,
					{
						id: payload.id,
						items: {
							data: selectAllItems(payload.items),
							pages: {
								page: payload.page,
								per_page: payload.per_page,
								total: payload.total,
							},
							error: null,
						},
					},
				],
			}),
		listRowsFailure: (state, { payload }) =>
			extend(state, {
				items: {
					...state.items,
					error: payload.error,
					loading: false,
				},
			}),

		deleteRow: (state) =>
			extend(state, {
				items: {
					...state.items,
					loading: true,
				},
			}),
		deleteRowFailure: (state, { payload }) =>
			extend(state, {
				items: {
					...state.items,
					error: payload.error,
					loading: false,
				},
			}),

		editTitle: (state, { payload }) =>
			extend(state, {
				database: { ...state.database, title: payload.title },
			}),
		editTitleSuccess: (state) =>
			extend(state, {
				database: {
					...state.database,
					loading: false,
				},
			}),
		editTitleFailure: (state, { payload }) =>
			extend(state, {
				database: {
					...state.database,
					loading: false,
					error: payload.error,
				},
			}),

		newText: (state, { payload }) =>
			extend(state, {
				editedRow: {
					...initialState.editedRow,
					description: payload.description,
				},
			}),

		editRow: (state, { payload }) => {
			// const new_items = {
			// 	data: state.items.data.map((item) => {
			// 		const itemCopy = cloneDeep(item);
			// 		if (item.id === payload.id) {
			// 			const itemData = itemCopy.data.map((columnData) => ({ value: payload.data[columnData.column], column: columnData.column }));
			// 			return extend(itemCopy, { data: itemData });
			// 		}
			// 		return itemCopy;
			// 	})
			// };
			// extend(state, { items: extend(state.items, new_items) });
		},
		editRowSuccess: (state, { payload }) =>
			extend(state, {
				editedRow: {
					...state.editedRow,
					loading: false,
				},
				items: {
					...state.items,
				},
			}),
		editRowFailure: (state, { payload }) =>
			extend(state, payload.previousState),
		createRow: (state, { payload }) =>
			extend(state, {
				editedRow: {
					...initialState.editedRow,
				},
			}),
		setShowModal: (state, { payload }) =>
			extend(state, {
				showModal: payload,
			}),
		createColumn: (state, { payload }) =>
			extend(state, {
				database: {
					...state.database,
					structure: [...state.database.structure, payload],
				},
			}),
		editDatabaseName: (state, { payload }) =>
			extend(state, {
				database: {
					...state.database,
					name: payload,
				},
			}),
		editDatabaseNameSuccess: (state) =>
			extend(state, {
				database: {
					...state.database,
					loading: false,
				},
			}),
		editDatabaseNameFailure: (state, { payload }) =>
			extend(state, {
				database: {
					...state.database,
					loading: false,
					error: payload.error,
				},
			}),
		editColumnName: (state, { payload }) => {
			return extend(state, { items: { ...state.items, loading: true } })
		},
		editColumnNameSuccess: (state, { payload }) =>
			extend(state, {
				database: {
					...state.database,
					structure: payload.structure,
				},
				items: {
					...state.items,
					data: payload.rows,
					loading: false,
				},
			}),

		deleteColumn: (state, { payload }) => {
			return extend(state, { items: { ...state.items, loading: true } })
		},
		deleteColumnSuccess: (state, { payload }) =>
			extend(state, {
				database: {
					...state.database,
					structure: payload.structure,
				},
				items: {
					...state.items,
					data: payload.rows,
					loading: false,
				},
			}),
	},
})

export const {
	resetState,

	create,
	createSuccess,
	createFailure,

	getDetail,
	getDetailSuccess,
	getDetailFailure,

	listRows,
	listRowsSuccess,
	listRowsFailure,

	deleteRow,
	deleteRowFailure,

	editTitle,
	editTitleSuccess,
	editTitleFailure,

	newText,
	editRow,
	editRowRequest,
	editRowSuccess,
	editRowFailure,

	createRow,
	createColumn,

	setShowModal,

	editDatabaseName,
	editDatabaseNameSuccess,
	editDatabaseNameFailure,

	editColumnName,
	editColumnNameSuccess,

	deleteColumn,
	deleteColumnSuccess,
} = actions

export { default as internalDatabaseDetailsSaga } from './sagas'

export default reducer
